const gridTypeConstants = {
  None: "None",
  properties: "SearchProperties",
  persons: "SearchPersons",
  demands: "SearchDemands",
  tasks: "SearchTasks",
  projects: "SearchProjects",
  companies: "SearchCompanies",
  histoires: "SearchHistoires",
  propertyProspectHistories: "SearchPropertyProspectHistories",
  personProperties: "PersonProperties",
  personDemands: "PersonDemands",
  personProposals: "PersonProposals",
  demandProposals: "DemandProposals",
};

export default gridTypeConstants;
